(function () {
    'use strict';

    angular
        .module('Lavpop-store.directives')
        .directive('galleryCarousel', GalleryCarousel);

    /** @ngInject */
    function GalleryCarousel($timeout, $rootScope) {
        function link(scope, element) {
            let options = {};
            let carousel = $(element);

            if (scope.options) {
                for (let key in scope.options) {
                    options[key] = scope.options[key];
                }
            }

            $timeout(() => {
                carousel.owlCarousel(options);

                carousel.on('initialize.owl.carousel', event => {
                    $rootScope.carouselLoaded = true;
                });
            });
        }

        return {
            link: link,
            restrict: 'AE',
            scope: {
                options: '=',
            }
        }
    }
}());